<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Student Wise Bill Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay"
                        :items="ay_list" item-text="ay" item-value="id" label="Select Academic Year" outlined
                        persistent-hint hint="Please Select Academic year" @change="putNull()"/>
                </v-col>
                <v-col cols="12" sm="2" md="2" >
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard" outlined
                         persistent-hint hint="Please Select Standard" @change="getDivisions()"/>
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="selected_div" :items="division_list"
                        item-text="division_name" item-value="id" label="Please Select Division" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-6 button" @click="getStudents()" :loading="fetch_loader">Fetch Students</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="students_list.length>0">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="student" :items="students_list"
                        item-text="name" item-value="prn" label="Please Select Student" persistent-hint return-object
                        hint="Please Select Student" @change="category=null"/>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="category" :items="category_list"
                        item-text="name" item-value="id" label="Please Select Category Type" persistent-hint multiple
                        hint="Please Select Category Type" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-6 button" @click="getStudentBillReport()" :loading="fetch_loader">Get Report</v-btn>
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-10">
            <v-col cols="12">
                <span v-if="report_data && report_data.length>0">
                     <span>
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>

                        <v-btn rounded class="no-display" color="success" outlined @click="downloadFile" :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>

                <div class="printing_area">
                    <table class="main-table">
                    <tr>
                        <td colspan="5" class="title1">
                            {{ org_basic_data.trust_name }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5" class="title2">
                            {{ org_basic_data.school_name }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5" class="title3">
                            {{ category_names.join(', ') }} Charges
                        </td>
                    </tr>

                    <tr>
                        <td colspan="2" style="font-size:14px;"><b>Name:</b> {{ learner_name }}</td>
                        <td colspan="2" style="font-size:14px;"><b>STD:</b> {{ standard }}</td>
                        <td style="font-size:14px;"><b>Roll No:</b> {{ rollno }}</td>
                    </tr>

                     <colgroup>
                        <col style="width: 8%">
                        <col style="width: 42%"> 
                        <col style="width: 13%">
                        <col style="width: 10%">
                        <col style="width: 17%">
                    </colgroup>

                    <tr>
                        <th>Sr No.</th>
                        <th>Contents</th>
                        <th>Rate</th>
                        <th>Qty</th>
                        <th>Total</th>
                    </tr>

                    <tr v-for="(row, index) in report_data" :key="row.key">
                        <td>{{ index + 1 }}</td>
                        <td>{{ row.item }}</td>
                        <td>{{ row.base_price }}</td>
                        <td>{{ row.qty }}</td>
                        <td>{{ row.price }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" style="font-size:14px; font-weight: bold;">Total: </td>
                        <td colspan="3" style="font-size:14px; font-weight: bold;">₹ {{ total_price }}</td>
                    </tr>
                </table>
                </div>
                    </span>        
                </span>
            </v-col>
            </v-row> 
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import * as XLSX from "xlsx";
    import "@/assets/css/color.css"; 
    export default {
       
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                fetch_loader: false,
                ay_list : [],
                selected_ay:"",
                selected_section : "",
                selected_div:"",
                selected_standard:"",
                display_ay:"",
                display_standard:"",
                student:"",
                category:[],
                division_list : [],
                standard_list : [],
                report_data : [],
                org_basic_data : [],
                students_list:[],
                category_list:[],
                category_names:[],
                standard:"",
                learner_name:"",
                rollno:"",
                total_price:""
            };
        },

        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        
            getStudents() {
                if(!this.selected_ay || !this.selected_standard || !this.selected_div){
                    this.showSnackbar("#b71c1c", "Select the Academic year and Standard and Division...");
                    return
                }
                const data = {
                    ay : this.selected_ay,
                    standard : this.selected_standard,
                    div : this.selected_div
                };
                axios
                    .post("/EduStore/fetchStudent", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.students_list = res.data.learner_list;
                            this.category_list = res.data.category_list;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false;
                    })
                    .finally(() => { });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            onload() {
                axios
                    .post("/QuizScheduling/getAllData")
                    .then((res) => {
                        if(res.data.flag =="YES"){
                            this.ay_list = res.data.ay_list;
                            this.semester_list = res.data.semester_list;
                            this.standard_list = res.data.standard_list
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
            },

            getDivisions() {
                const data={
                    ay: this.selected_ay,
                    standard: this.selected_standard
                }
                axios
                    .post("/EduStore/getDivisionsOfAy",data)
                    .then((res) => {
                        if(res.data.flag =="YES"){
                           this.division_list = res.data.division_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
            },

            getStudentBillReport() {
                this.fetch_loader = true;
                if(!this.student || !this.category){
                    this.showSnackbar("#b71c1c", "Please Select Student and Category Type");
                    return
                }
                const data = {
                    student: this.student.prn,
                    category_list: this.category,
                    learner_div : this.student.id
                };
                axios
                    .post("/EduStore/getStudentBillReport", data)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.report_data = res.data.report_data;
                            this.org_basic_data = res.data.org_basic_data;
                            this.category_names = res.data.category_names;
                            this.learner_name = res.data.learner_name;
                            this.standard = res.data.standard;
                            this.rollno = res.data.roll_no;
                            this.total_price = res.data.total_price;
                            this.showSnackbar("success", "Data Fetched Successfully");
                        }else if (res.data.flag === "NA"){
                             this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false;
                    })
                    .finally(() => { 
                        this.fetch_loader = false; 
                    });
            },
            putNull(){
                this.selected_standard = null;
                this.selected_div = null;
            },
            downloadFile() {
                this.loader = true;
                try {
                    const pad1 = (text) => " ".repeat(90) + text;
                    const pad2 = (text) => {
                        const len = (this.category_names || []).length;
                        const space = len < 3 ? 100 : 60;
                        return " ".repeat(space) + text;
                    };

                    const rows = [
                        [pad1(this.org_basic_data.trust_name), "", "", "", ""],
                        [pad1(this.org_basic_data.school_name), "", "", "", ""],
                        [pad2(this.category_names.join(", ") + " Charges"), "", "", "", ""],
                        [`Name: ${this.learner_name}`, "", `STD: ${this.standard}`, "", `Roll No: ${this.rollno}`],
                        ["Sr No.", "Contents", "Rate", "Qty", "Total"],
                        ...this.report_data.map((row, index) => [index + 1, row.item, row.base_price, row.qty, row.price]),
                        ["Total:", "", `Rs. ${this.total_price}`, "", ""]
                    ];
                    const ws = XLSX.utils.aoa_to_sheet(rows);

                    ws["!cols"] = [
                        { wch: 10 },
                        { wch: 45 },
                        { wch: 15 },
                        { wch: 10 },
                        { wch: 20 },
                    ];

                    const lastRow = rows.length;
                    ws["!merges"] = [
                        { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
                        { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
                        { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
                        { s: { r: 3, c: 0 }, e: { r: 3, c: 1 } },
                        { s: { r: 3, c: 2 }, e: { r: 3, c: 3 } },
                        { s: { r: lastRow - 1, c: 0 }, e: { r: lastRow - 1, c: 1 } },
                        { s: { r: lastRow - 1, c: 2 }, e: { r: lastRow - 1, c: 4 } },
                    ];

                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Bill Report");
                    XLSX.writeFile(wb, "Student_Bill_Report.xlsx");
                    this.showSnackbar("success", "File Downloaded Successfully");
                } catch (e) {
                    this.showSnackbar("#b71c1c", "Export failed: " + e.message);
                } finally {
                    this.loader = false;
                }
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style>
.main-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.main-table th,
.main-table td {
    border: 1px solid #000;
    text-align: center;
    padding: 6px;
    font-size: 14px;
}

.main-table td.title1 {
    font-size: 18px;
    font-weight: bold;
}

.main-table td.title2 {
    font-size: 18px;
    font-weight: bold;
}

.main-table td.title3 {
    font-size: 16px;
    font-weight: bold;
}

@media print {

    body * {
        visibility: hidden !important;
    }

    .printing_area,
    .printing_area * {
        visibility: visible !important;
    }

    .printing_area {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        border: none;
    }

    table,
    th,
    td {
        border: 1px solid #000 !important;
    }
   
    @page {
        size: A4 portrait;
        margin: 5mm;
    }
}
</style>